(function () {
    'use strict';

    angular
        .module('partners')
        .controller('ClientsPartnersListController', ClientsPartnersListController);

    ClientsPartnersListController.$inject = ['partnersList','ClientsPartnersService', 'ExpoService','$uibModal','$q'];

    function ClientsPartnersListController(partnersList, ClientsPartnersService, ExpoService, $uibModal, $q) {
        var vm = this;

        vm.partners = partnersList.data.data;

        vm.expos = [];
        vm.expoSelected = [];
        vm.exposAll = [{
            name: '--- All ---'
        }];

        vm.getAll          = getAll;
        vm.openRegisteredInformation = openRegisteredInformation;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.totalItems   = partnersList.data.total;
        vm.currentPage  = partnersList.data.current_page;
        vm.itemsPerPage = partnersList.data.per_page;
        vm.page         = 1;

        activate();

        function setPage(page) {
            vm.currentPage = page;
        };

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        };


        function activate() {
            vm.getAll();
        }

        function getAll() {
            ClientsPartnersService.getAll().then(function(response) {
                vm.expos = vm.exposAll.concat(response.data);
            }).catch(function(err) {
            });
        }

        function openRegisteredInformation(partner) {
            $uibModal.open({
                templateUrl: 'templates/partners/show/registered.modal.html',
                controller: 'PartnerModalController',
                controllerAs:'vm',
                resolve: {
                    partner: function() {
                        return partner;
                    }
                }
            });
        }
    }

})();